import { Component, EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SESSION_STORAGE, StorageService, User } from '@phdsoft/common';
import THREE from '@phdsoft/three';
import { IWindow } from '@phdsoft/window';
import { MessageService } from 'primeng/api';
import { ELEMENTSTYPESIDS } from 'projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds';
import { Observable } from 'rxjs';
import { AssetFilesService } from 'src/app/admin/services/asset-files.service';
// import { InspectionService } from 'src/app/admin/services/inspection.service';
import { RegionsService } from 'src/app/admin/services/regions.service';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { FilterService } from 'src/app/filter/filter.service';
import { DigitalTwinService } from 'src/app/digital-twin/digital-twin.service';
import { WorkableElement } from 'src/app/platform/busines-data/SectionElements/WorkableElement';
import { AssetService } from 'src/app/shared/services/asset.service';
import { Vector3 } from 'three';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'phdsoft-join-flanges-config',
  templateUrl: "./join-flanges-config.component.html",
  styleUrls: ["./join-flanges-config.component.scss"]
})
export class JoinFlangesConfigComponent {

  public optionsWindow: IWindow = {
    Position: 'favorite',
    PositionMini: '',
    VisibleMini: false,
    Header: {
      Icon: 'info',
      VisibleTitle: false,
      Title: 'New User',
      Visible: true,
    },
    Footer: {
      ShowCancel: false,
      ShowOk: true,
      Visible: true,
    },
  };


  private _fullIdsElements : Array<WorkableElement>;
  public get completedIdsElements() : Array<WorkableElement> {
    return this._fullIdsElements;
  }
  public set completedIdsElements(v : Array<WorkableElement>) {
    this._fullIdsElements = v;
  }


  private _width: number = 1;
  private _height: number = 1;
  private _depth: number = 1;

  public get width(){
    return this._width
  }
  public set width(v: number){
    this._width = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }

  public get height(){
    return this._height
  }
  public set height(v: number){
    this._height = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }

  public get depth(){
    return this._depth
  }
  public set depth(v: number){
    this._depth = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }


  public get formatedWidth(){
    return (this.width * 100).toFixed(0)
  }

  public get formatedHeight(){
    return (this.height * 100).toFixed(0)
  }

  public get formatedDepth(){
    return (this.depth * 100).toFixed(0)
  }

  public get dimensions(){
    return new Vector3(this.width, this.height, this.depth)
  }


  constructor(
    public dialogRef: MatDialogRef<JoinFlangesConfigComponent>,
    private assetManager: AssetManager,
    private digitalTwinService: DigitalTwinService,
    private snackBar: MatSnackBar,
    private readonly regionsService: RegionsService,
    private readonly assetFilesService: AssetFilesService,
    private messageService: MessageService,
    private storageService: StorageService,
    private filterService: FilterService,
    private assetService: AssetService,
    // private inspectionService: InspectionService,
  ) {}

  updateBoxDimensions(){
    this.assetManager.updateCriticalAreaBox(this.width, this.height, this.depth)
  }

  submit(){
    this.dialogRef.close()
  }

  onSelectElementJoinFlange() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'JOINFLANGES';
    } else {
      // this.assetManager.setFunctionalityModeNone()
    }
    console.log('onInspectSelectButtonClick button clicked!');
  }

  onExecuteChangeButtonClick() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.joinFlanges();
    } else {
      // this.assetManager.setFunctionalityModeNone()
      // this.assetManagerBoxMeasureTool.clearWeightMeasurementToolMode()
    }
    console.log('onExecuteChangeButtonClick button clicked! CompletedIds');
  }

  save() {
    this.saveCompletedIds();

    console.log('onStopInspectionChangeButtonClick button clicked!');
  }

  cancel() {
    if(this.assetManager.joinFlanges){
      for (const element of this.assetManager.joinFlanges) {
        element.currentRenderMaterial = element.defaultMaterial;
      }
    }
    console.log('cancel button clicked!');

    this.assetManager.joinFlanges = [];
    this.assetManager.setFunctionalityModeNone();
  }

  finished(){
    this.snackBar.open('Join Flanges Completed', '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration:3000
    });
  }
  private user = null

  public async joinFlanges(){
    console.log(this.assetManager.joinFlanges)

    this.user = await this.storageService.getItem<User>(
      SESSION_STORAGE.USER,
    )
    if(this.assetManager.joinFlanges && this.assetManager.joinFlanges.length === 2){
      const files = [];
      this.assetManager.asset.assetInfo = await this.assetService.getFromBackEnd(this.assetManager.asset.assetInfo.AssetId);
      const filesProperties = [];
      let srcElementId = this.assetManager.joinFlanges[1].properties.ElementId
      let destElementId = this.assetManager.joinFlanges[0].properties.ElementId

      let flange1 = this.assetManager.joinFlanges[0]
      let flange2 = this.assetManager.joinFlanges[1]
      flange2.Guid = flange1.Guid;

      const blobPath = this.assetManager.asset.assetInfo.Collections[0].BlobPaths.find(item => item.RegionId == this.assetManager.getCurrentRegionId());
      let dataFile = await this.regionsService.getFileRegion(blobPath.DefaultGeoPath);
      let dataFileProperties = await this.regionsService.getFileRegion(blobPath.PropertiesPath);



      var elementToKeepIndex = dataFile.findIndex(x => x.ElementId === destElementId);
      var elementToDeleteIndex = dataFile.findIndex(x => x.ElementId === srcElementId);

      var elementToKeepIndexProperties = dataFileProperties.findIndex(x => x.ElementId === destElementId);
      var elementToDeleteIndexProperties = dataFileProperties.findIndex(x => x.ElementId === srcElementId);

      console.log("Geometry")
      console.log(dataFile[elementToKeepIndex]);
      console.log(dataFile[elementToDeleteIndex]);


      if(elementToDeleteIndex >= 0 && elementToKeepIndex >= 0)
      {
        dataFile[elementToKeepIndex].Geometries3D[0].GeometryV.push(...dataFile[elementToDeleteIndex].Geometries3D[0].GeometryV);

        if(dataFile[elementToKeepIndex].Geometries3D[0].GeometryF.length > 0 && dataFile[elementToDeleteIndex].Geometries3D[0].GeometryF.length >0){
          var indexes = dataFile[elementToDeleteIndex].Geometries3D[0].GeometryF.map(x => x+dataFile[elementToKeepIndex].Geometries3D[0].GeometryF.length);
          dataFile[elementToKeepIndex].Geometries3D[0].GeometryF = indexes;
        }
        dataFile.splice(elementToDeleteIndex, 1);
      }

      if(elementToDeleteIndexProperties >= 0 && elementToKeepIndexProperties >= 0)
      {
        dataFileProperties.splice(elementToDeleteIndexProperties, 1);
      }

      console.log("Property")
      console.log(dataFileProperties[elementToKeepIndexProperties]);
      console.log(dataFileProperties[elementToDeleteIndexProperties]);

      const file = new File([new Blob([JSON.stringify(dataFile)], { type: 'text/plain' })], this.assetManager.getCurrentRegionId() + ".json");
      files.push(file);

      let collectionInfo = {
        AssetId: this.assetManager.asset.assetInfo.AssetId,
        CollectionId: this.assetManager.asset.assetInfo.Collections[0]?.CollectionId ?? null,
        Success: false,
        // regionId: null
      };

      let formData: FormData = new FormData();
      formData.append('collectionInfo', JSON.stringify(collectionInfo));
      files.forEach(file => {
        formData.append('formFiles', file);
      });

      const observables: Observable<any>[] = [];

      const filesArray: File[] = []
      files.forEach( file => {
        filesArray.push(file)
      });


      const fileProperties = new File([new Blob([JSON.stringify(dataFileProperties)], { type: 'text/plain' })], this.assetManager.getCurrentRegionId() + ".json");
      filesProperties.push(fileProperties);

      let formDataProperties: FormData = new FormData();
      formDataProperties.append('collectionInfo', JSON.stringify(collectionInfo));
      filesProperties.forEach(file => {
        formDataProperties.append('formFiles', file);
      });

      const observablesProperties: Observable<any>[] = [];

      const filesArrayProperties: File[] = []
      filesProperties.forEach( file => {
        filesArrayProperties.push(file)
      });

      this.assetFilesService.postGeometries(formData).subscribe(
        {complete: () => {
          this.messageService.add({ severity: 'success', summary: 'Sending files to server...', detail: 'Success', life: 3000 });

          this.assetFilesService.postProperties(formDataProperties).subscribe(
            {complete: () => {
              this.messageService.add({ severity: 'success', summary: 'Sending files to server...', detail: 'Success', life: 3000 });

              this.digitalTwinService.postJsonFilesToGltf(filesArray, this.assetManager.asset.assetInfo.AssetId, collectionInfo.CollectionId, this.user.id)
              .subscribe(async (result) => {
                this.messageService.add({ severity: 'success', summary: 'Import Geometries For GlTF', detail: 'Files imported', life: 10000 });
                this.cancel();
                this.filterService.joinFlangesRetarget(this.assetManager.asset.assetInfo.AssetId,this.assetManager.getCurrentRegionId(),
                srcElementId, destElementId)
                .subscribe(async (result) => {
                  this.messageService.add({ severity: 'success', summary: 'Import Geometries For GlTF', detail: 'Files imported', life: 10000 });
                  this.finished();
                },
                  (error) => {
                    this.messageService.add({ severity: 'error', summary: 'Import Geometries Failed', detail: error.message, life: 10000 })
                    this.cancel();

                    // this.loading = false
                  },
                  () => {
                    this.cancel();
                    // this.finished();
                    // this.loading = false
                    // this.geometryForGlftFileUpload.nativeElement.value = null
                  }
                );

              },
                (error) => {
                  this.messageService.add({ severity: 'error', summary: 'Import Geometries Failed', detail: error.message, life: 10000 })
                  this.cancel();

                  // this.loading = false
                },
                () => {
                  this.cancel();
                  // this.loading = false
                  // this.geometryForGlftFileUpload.nativeElement.value = null
                }
              );

            },
            error: (err: any) => {
              console.log(err)
              this.cancel();

            }
          })
        },
        error: (err: any) => {
          console.log(err)
          this.cancel();

        }
      })
    }


  }

  public async saveCompletedIds(){
    if(this._fullIdsElements && this._fullIdsElements.length > 0){
      await this.digitalTwinService.updatePropertiesList(this._fullIdsElements.map(x => x.properties), this._fullIdsElements[0].regionId, this.assetManager.asset.assetInfo.AssetId);

    }
    this.cancel();
    // this._completedIdsElements = []

    this.snackBar.open('Saving Full Id Completed', '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration:3000
    });
  }
}

